import React, { useEffect, useState, useImperativeHandle } from 'react';
import { Form, InputNumber } from 'antd';

const FormPoints = ( { form, modifiedCallback, ref } ) => {      
    const [ pointsValue, setPointsValue ] = useState( 0 ); 

    useEffect( () => {
        setPointsValue( form.getFieldValue( 'points' ) );
    }, [ form ] );

    useImperativeHandle( ref, () => ( {
        reset() {
            form.setFieldsValue( { pointsIsModified: false } ); 
            form.setFieldsValue( { pointsModified: undefined } ); 
            setPointsValue( form.getFieldValue( 'points' ) );
            modifiedCallback( false ); 
        }
    } ) );
    
    const updateModified = () => { 
        if ( form.getFieldValue( 'points' ) !== form.getFieldValue( 'pointsModified' ) ) {
            form.setFieldsValue( { pointsIsModified: true } ); 
            modifiedCallback( true ); 
        } else {
            form.setFieldsValue( { pointsIsModified: false } ); 
            form.setFieldsValue( { pointsModified: undefined } ); 
            modifiedCallback( false ); 
        }
    };
    
    const handleStepChange = ( i ) => { 
        setPointsValue( i );
        form.setFieldsValue( { pointsModified: i } ); 
        updateModified();
    };
    
    const handleValueChange = ( i ) => { 
        setPointsValue( i );
        form.setFieldsValue( { pointsModified: i } ); 
        updateModified();
    };

    return (
        <div className="form-item-points">
            <Form.Item 
                label={ <h4 style={ { marginBottom: '0' } }>Completion Points</h4> }
            >
                <InputNumber
                    min={ 0 } 
                    max={ 1000 }
                    formatter={ value => value.replace( /[^0-9]/g, '' ) }
                    value={ pointsValue }
                    onStep={ handleStepChange }
                    onChange={ handleValueChange } 
                />
            </Form.Item>
        </div>
    );
};

export default FormPoints;
